// extracted by mini-css-extract-plugin
module.exports = {"btn":"BuyButton_btn__OvRbp"};